<div id="home">
  <header>
    <nav class="navbar nav-bar-programs">
      <div class="container">
        <a class="navbar-brand main-logo" routerLink="/">
          <img alt="IPDJ" class="logo-programa" src="/content/images/brand/ipdj.png" />
        </a>
      </div>
    </nav>
    <div class="container main-banner">JUVENTUDE</div>
  </header>

  <section class="noticias text-center">
    <p class="title" style="font-weight: lighter; margin-bottom: 33px">TUTORIAIS</p>
    <div class="container mb-4">
      <div class="row">
        <div class="col col-lg-4">
          <div class="box">
            <div class="boxed-image">
              <iframe
                width="220"
                height="190"
                src="https://www.youtube.com/embed/gPe8KjDU8Ig"
                title=" Como efetuar o registo no Registo Único do IPDJ"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
              ></iframe>
            </div>
            <div class="box-text" style="height: auto">
              <div class="col-xs-24">
                <p class="boxed-title color-ferias">Como efetuar o registo no Registo Único do IPDJ</p>
              </div>
            </div>
          </div>
        </div>
        <div class="col col-lg-4">
          <div class="box">
            <div class="boxed-image">
              <iframe
                width="220"
                height="190"
                src="https://www.youtube.com/embed/TiqR9JcOt1o"
                title="Como aceder à plataforma dos Programas da Juventude"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
              ></iframe>
            </div>
            <div class="box-text" style="height: auto">
              <div class="col-xs-24">
                <p class="boxed-title color-ferias">Como aceder à plataforma dos Programas da Juventude</p>
              </div>
            </div>
          </div>
        </div>
        <div class="col col-lg-4">
          <div class="box">
            <div class="boxed-image">
              <iframe
                width="220"
                height="190"
                src="https://www.youtube.com/embed/Fz1t8VmtpxY"
                title="Como alterar os dados pessoais no Registo Único do IPDJ"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
              ></iframe>
            </div>
            <div class="box-text" style="height: auto">
              <div class="col-xs-24">
                <p class="boxed-title color-ferias">Como alterar os dados pessoais no Registo Único do IPDJ</p>
              </div>
            </div>
          </div>
        </div>
        <div class="col col-lg-4">
          <div class="box">
            <div class="boxed-image">
              <iframe
                width="220"
                height="190"
                src="https://www.youtube.com/embed/akSBsrPCFbU"
                title="Como registar uma entidade no Registo Único do IPDJ"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
              ></iframe>
            </div>
            <div class="box-text" style="height: auto">
              <div class="col-xs-24">
                <p class="boxed-title color-ferias">Como registar uma entidade no Registo Único do IPDJ</p>
              </div>
            </div>
          </div>
        </div>
        <div class="col col-lg-4">
          <div class="box">
            <div class="boxed-image">
              <iframe
                width="220"
                height="190"
                src="https://www.youtube.com/embed/jzoHUSJVZr8"
                title="Como fazer uma candidatura nos Programas da Juventude"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
              ></iframe>
            </div>
            <div class="box-text" style="height: auto">
              <div class="col-xs-24">
                <p class="boxed-title color-ferias">Como fazer uma candidatura nos Programas da Juventude</p>
              </div>
            </div>
          </div>
        </div>
        <div class="col col-lg-4">
          <div class="box">
            <div class="boxed-image">
              <iframe
                width="220"
                height="190"
                src="https://www.youtube.com/embed/mPvoPk2pIco"
                title="Como inserir documentos no Registo Único do IPDJ"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
              ></iframe>
            </div>
            <div class="box-text" style="height: auto">
              <div class="col-xs-24">
                <p class="boxed-title color-ferias">Como inserir documentos no Registo Único do IPDJ</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>
